import fallbackContent from "./genius-content.json";
import { setContentLoadMeta, type ContentLoadMeta } from "./contentSource";
import { getGcsContentJsonUrl } from "./gcsConfig";
import type { GeniusContent } from "./types";

export interface ContentLoadResult {
  content: GeniusContent;
  meta: ContentLoadMeta;
}

export async function loadGeniusContent(): Promise<ContentLoadResult> {
  const remoteUrl = getGcsContentJsonUrl();
  const gcsBaseUrl = remoteUrl?.replace(/\/genius-content\.json$/, "");

  if (remoteUrl) {
    try {
      const response = await fetch(remoteUrl, { cache: "no-cache" });
      if (response.ok) {
        const content = (await response.json()) as GeniusContent;
        const meta: ContentLoadMeta = {
          jsonSource: "gcs",
          gcsBaseUrl,
          remoteUrl,
          loadedAt: new Date().toISOString(),
        };
        setContentLoadMeta(meta);
        return { content, meta };
      }

      const meta: ContentLoadMeta = {
        jsonSource: "local",
        gcsBaseUrl,
        remoteUrl,
        fallbackReason: `GCS returned HTTP ${response.status}`,
        loadedAt: new Date().toISOString(),
      };
      setContentLoadMeta(meta);
      return { content: fallbackContent as GeniusContent, meta };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      const meta: ContentLoadMeta = {
        jsonSource: "local",
        gcsBaseUrl,
        remoteUrl,
        fallbackReason: `GCS fetch failed: ${message}`,
        loadedAt: new Date().toISOString(),
      };
      setContentLoadMeta(meta);
      console.warn("[Genius CMS] Using local JSON fallback.", error);
      return { content: fallbackContent as GeniusContent, meta };
    }
  }

  const meta: ContentLoadMeta = {
    jsonSource: "local",
    gcsBaseUrl,
    remoteUrl,
    fallbackReason: "pip_GCS_url missing in ENVIRONMENT_CONFIGS",
    loadedAt: new Date().toISOString(),
  };
  setContentLoadMeta(meta);
  return { content: fallbackContent as GeniusContent, meta };
}

export { fallbackContent };
